export const ROUTES = {
  home: '/',
} as const;
